var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuoteLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.3594 6.292C3.7624 4.771 5.8854 4 8.6684 4H9.6684V6.819L8.8644 6.98C7.4944 7.254 6.5414 7.793 6.0314 8.584C5.76529 9.01013 5.61437 9.49804 5.5934 10H8.6684C8.93361 10 9.18797 10.1054 9.3755 10.2929C9.56304 10.4804 9.6684 10.7348 9.6684 11V18C9.6684 19.103 8.7714 20 7.6684 20H1.6684C1.40318 20 1.14883 19.8946 0.96129 19.7071C0.773754 19.5196 0.668397 19.2652 0.668397 19V14L0.671397 11.081C0.662397 10.97 0.472397 8.34 2.3594 6.292ZM18.6684 20H12.6684C12.4032 20 12.1488 19.8946 11.9613 19.7071C11.7738 19.5196 11.6684 19.2652 11.6684 19V14L11.6714 11.081C11.6624 10.97 11.4724 8.34 13.3594 6.292C14.7624 4.771 16.8854 4 19.6684 4H20.6684V6.819L19.8644 6.98C18.4944 7.254 17.5414 7.793 17.0314 8.584C16.7653 9.01013 16.6144 9.49804 16.5934 10H19.6684C19.9336 10 20.188 10.1054 20.3755 10.2929C20.563 10.4804 20.6684 10.7348 20.6684 11V18C20.6684 19.103 19.7714 20 18.6684 20Z",
    fill: "#D4BC87"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuoteLeft);
export default __webpack_public_path__ + "static/media/quote-left.3c51cd297a158562001284b1b451d7b8.svg";
export { ForwardRef as ReactComponent };